import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(duration);
dayjs.extend(isBetween);

// there is a corner case when js timestamp is also verified by our function (create new conversation)
export const convertPythonTimestamp = (timestamp) =>
  timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;

const isTimestampFromYesterday = (convTimestamp) => {
  const yesterday = dayjs().subtract(1, 'day').startOf('day');
  return dayjs(convTimestamp).startOf('day').isSame(yesterday);
};

const isTimestampFromToday = (convTimestamp) => dayjs().isSame(dayjs(convTimestamp), 'day');

const isTimestampFromLastWeek = (convTimestamp) => dayjs(convTimestamp).isAfter(dayjs().subtract(1, 'week'));

export const getGroupTimestamp = (timestamp) => {
  const jsTimestamp = convertPythonTimestamp(timestamp);
  if (isTimestampFromToday(jsTimestamp)) {
    return 'conversation.groupByTime.today';
  } else if (isTimestampFromYesterday(jsTimestamp)) {
    return 'conversation.groupByTime.yesterday';
  } else if (isTimestampFromLastWeek(jsTimestamp)) {
    return 'conversation.groupByTime.lastWeek';
  } else {
    return 'conversation.groupByTime.older';
  }
};

export const formatTimestamp = (timestamp) => {
  const jsTimestamp = convertPythonTimestamp(timestamp);
  const now = new Date();
  const inputDate = new Date(jsTimestamp);
  const diffTime = Math.abs(now - inputDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 1 && now.getDate() === inputDate.getDate()) {
    // If the timestamp is from today, show hours ago
    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    if (diffHours < 1) {
      return 'Just now';
    }
    return `${diffHours}h ago`;
  } else {
    // Otherwise, show the date in "DD MMM" format
    return inputDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
};

export const sortByTimestamp = (array) =>
  array.sort((item1, item2) => convertPythonTimestamp(item2.timestamp) - convertPythonTimestamp(item1.timestamp));

export const formatTimestampToYearAndMonth = (timestamp) => {
  dayjs.extend(localizedFormat);

  return dayjs(timestamp).format('LL');
};

export const calculatePassedTime = (timestamp) => {
  const today = new Date();
  const x = dayjs(convertPythonTimestamp(today.getTime()));
  const y = dayjs(convertPythonTimestamp(timestamp));
  const duration = x.diff(y);
  const durationObject = dayjs.duration(duration);

  if (durationObject.years() > 0) {
    return `${durationObject.years()} ${durationObject.years() === 1 ? 'year ago' : 'years ago'}`;
  }
  if (durationObject.months() > 0) {
    return `${durationObject.months()} ${durationObject.months() === 1 ? 'month ago' : 'months ago'}`;
  }

  if (durationObject.days() > 0) {
    return `${durationObject.days()} ${durationObject.days() === 1 ? 'day ago' : 'days ago'}`;
  }

  if (durationObject.hours() > 0) {
    return `${durationObject.hours()} ${durationObject.hours() === 1 ? 'hour ago' : 'hours ago'}`;
  }

  return durationObject.minutes() === 0
    ? 'Just now'
    : `${durationObject.minutes()} ${durationObject.minutes() === 1 ? 'minute ago' : 'minutes ago'}`;
};

export const dateTimeIsBetween = (start, end) => {
  const now = new Date();
  const nowTimestamp = dayjs(convertPythonTimestamp(now.getTime()));

  return dayjs(nowTimestamp).isBetween(start, dayjs(end), 'minutes', '[]');
};
